<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import ToolTester from './ToolTester.vue';

const props = defineProps({
  mcpServer: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['close']);

const { t } = useI18n();
const dialogRef = ref(null);

const handleClose = () => {
  emit('close');
};

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="$t('CAPTAIN.MCP_SERVERS.TOOL_TESTER.TITLE')"
    size="large"
    @close="handleClose"
  >
    <div class="flex flex-col gap-4 max-h-[70vh] overflow-y-auto p-4">
      <div class="text-sm text-n-slate-11">
        <strong class="text-n-slate-12">{{ mcpServer.title }}</strong>
        <span class="mx-2">•</span>
        <span>{{ mcpServer.description }}</span>
      </div>

      <ToolTester :mcp-server-id="mcpServer.id" />
    </div>

    <template #footer>
      <div class="flex justify-end">
        <button
          type="button"
          class="px-4 py-2 text-sm font-medium text-n-slate-12 hover:bg-n-alpha-black2 rounded-lg transition-colors"
          @click="handleClose"
        >
          {{ $t('CAPTAIN.FORM.CANCEL') }}
        </button>
      </div>
    </template>
  </Dialog>
</template>
